import {minimumVersion} from './config.js';
// 新协议
function kkmhhybrid_notice_ios_h5_pay (opt) {
    hybrid({
        hybridParam: {
            schema: "kkmhhybrid",
            tagname: "notice_ios_h5_pay",
        },
        callback: function (res) {
          opt.callback && opt.callback(res);
        }
    });
}

// 旧协议
function kkhybrid_iosH5Pay (opt) {
    hybrid({
        hybridParam: {
            schema: "kkhybrid",
            tagname: "iosH5Pay",
        },
        callback: function (res) {
          opt.callback && opt.callback(res);
        }
    });
}


/**
 * 通知Ios支付成功（ios-h5支付，三方回掉快看H5页，H5页用此协议通知给ios会员中心）<br>
 * kkmhhybrid://notice_ios_h5_pay，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=283838842}<br>
 * kkhybrid://iosH5Pay，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=19901071}<br>
 * @param {Object} opt 参数对象
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function notice_ios_h5_pay (opt, criticalAppVersion) {
    var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion,minimumVersion);
    if(allow) {
        // 调用新协议
        kkmhhybrid_notice_ios_h5_pay(opt);
    } else {
        // 调用旧协议
        kkhybrid_iosH5Pay(opt);
    }
}

export default notice_ios_h5_pay;




// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/notice_ios_h5_pay/index.js